/**
 * Sidebar Navigation Component
 * Displays navigation links for admin pages
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  CreditCard,
  BarChart3,
  Settings,
  UtensilsCrossed,
  Users,
} from 'lucide-react';

interface NavItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}

const Sidebar: React.FC = () => {
  const location = useLocation();

  const navItems: NavItem[] = [
    {
      label: 'Dashboard',
      path: '/dashboard',
      icon: <LayoutDashboard className="w-5 h-5" />,
    },
    {
      label: 'Restaurants',
      path: '/tenants',
      icon: <Building2 className="w-5 h-5" />,
    },
    {
      label: 'Menu Management',
      path: '/menu-management',
      icon: <UtensilsCrossed className="w-5 h-5" />,
    },
    {
      label: 'Staff Management',
      path: '/staff-management',
      icon: <Users className="w-5 h-5" />,
    },
    {
      label: 'Billing',
      path: '/billing',
      icon: <CreditCard className="w-5 h-5" />,
    },
    {
      label: 'Analytics',
      path: '/analytics',
      icon: <BarChart3 className="w-5 h-5" />,
    },
    {
      label: 'Settings',
      path: '/settings',
      icon: <Settings className="w-5 h-5" />,
    },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="w-64 bg-gray-900 text-white h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-2xl font-bold">FoodHub</h1>
        <p className="text-sm text-gray-400">Admin Dashboard</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
              isActive(item.path)
                ? 'bg-blue-600 text-white'
                : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            {item.icon}
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-800">
        <p className="text-xs text-gray-500">© 2025 FoodHub SaaS</p>
      </div>
    </div>
  );
};

export default Sidebar;

